import React, { useState } from 'react';
import { PlusCircleIcon, UserPlusIcon } from 'lucide-react';
interface TeamMember {
  email: string;
  role: string;
}
export function InviteTeammates() {
  const [teamMembers, setTeamMembers] = useState<TeamMember[]>([{
    email: '',
    role: 'Member'
  }]);
  const [isLoading, setIsLoading] = useState(false);
  const handleEmailChange = (index: number, email: string) => {
    const updatedMembers = [...teamMembers];
    updatedMembers[index].email = email;
    setTeamMembers(updatedMembers);
  };
  const handleRoleChange = (index: number, role: string) => {
    const updatedMembers = [...teamMembers];
    updatedMembers[index].role = role;
    setTeamMembers(updatedMembers);
  };
  const addTeamMember = () => {
    setTeamMembers([...teamMembers, {
      email: '',
      role: 'Member'
    }]);
  };
  const handleContinue = async () => {
    setIsLoading(true);
    // Filter out empty email entries
    const validInvites = teamMembers.filter(member => member.email.trim() !== '');
    try {
      // Here you could send invites to your backend
      // For now, just simulate and navigate
      console.log('Inviting team members:', validInvites);
      setTimeout(() => {
        setIsLoading(false);
        // Navigate to main app
        window.location.href = '/';
      }, 500);
    } catch (error) {
      console.error('Error sending invites:', error);
      setIsLoading(false);
    }
  };
  const handleSkip = () => {
    // Navigate directly to main app
    window.location.href = '/';
  };
  return <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4" data-id="element-82">
    <div className="max-w-2xl w-full" data-id="element-83">
      <div className="text-center mb-10" data-id="element-84">
        <h1 className="text-4xl font-bold mb-2" data-id="element-85">Invite</h1>
        <p className="text-gray-600" data-id="element-86">
          Add team members to collaborate on your MGA portal
        </p>
      </div>
      <div className="bg-white p-8 rounded-lg shadow-sm border border-gray-200 mb-6" data-id="element-87">
        <div className="mb-8" data-id="element-88">
          <div className="flex items-center mb-6" data-id="element-89">
            <UserPlusIcon className="mr-3 text-blue-600" size={24} data-id="element-90" />
            <h2 className="text-2xl font-semibold" data-id="element-91">Invite your teammates</h2>
          </div>
          <p className="text-gray-600 mb-6" data-id="element-92">
            Work in the MGA portal is more effective with your team. Invite
            them now to collaborate on your feasibility study.
          </p>
          <div className="space-y-4" data-id="element-93">
            <div className="grid grid-cols-4 gap-4 font-medium text-sm text-gray-700 mb-1" data-id="element-94">
              <div className="col-span-3" data-id="element-95">Email</div>
              <div className="col-span-1" data-id="element-96">Role</div>
            </div>
            {teamMembers.map((member, index) => <div key={index} className="grid grid-cols-4 gap-4" data-id="element-97">
              <div className="col-span-3" data-id="element-98">
                <input type="email" value={member.email} onChange={e => handleEmailChange(index, e.target.value)} placeholder="colleague@company.com" className="w-full p-3 border border-gray-300 rounded-md" data-id="element-99" />
              </div>
              <div className="col-span-1" data-id="element-100">
                <select value={member.role} onChange={e => handleRoleChange(index, e.target.value)} className="w-full p-3 border border-gray-300 rounded-md" data-id="element-101">
                  <option value="Member" data-id="element-102">Member</option>
                  <option value="Admin" data-id="element-103">Admin</option>
                  <option value="Viewer" data-id="element-104">Viewer</option>
                </select>
              </div>
            </div>)}
            <button onClick={addTeamMember} className="flex items-center text-blue-600 font-medium text-sm mt-2" data-id="element-105">
              <PlusCircleIcon size={16} className="mr-2" data-id="element-106" />
              Add another
            </button>
          </div>
        </div>
        <div className="flex flex-col space-y-3" data-id="element-107">
          <button onClick={handleContinue} className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-4 rounded-md transition duration-150 ease-in-out" disabled={isLoading} data-id="element-108">
            {isLoading ? 'Processing...' : 'Continue'}
          </button>
          <button onClick={handleSkip} className="w-full text-gray-600 font-medium py-2 px-4 rounded-md transition duration-150 ease-in-out" data-id="element-109">
            I'll do it later
          </button>
        </div>
      </div>
    </div>
  </div>;
}